
export type GetDashboardActivitiesParams = {
limit?: string;
};
